import Model from 'flarum/common/Model';

export default class TaroCase extends Model {}

Object.assign(TaroCase.prototype, {
  discussionId: Model.attribute('discussion_id'),
  userId: Model.attribute('user_id'),
  requiredLevel: Model.attribute('requiredLevel'),
  visibility: Model.attribute('visibility'),
  aiReportVisibility: Model.attribute('ai_report_visibility'),
  interpretationVisibility: Model.attribute('interpretation_visibility'),
  mentorReviewVisibility: Model.attribute('mentor_review_visibility'),
  feedbackVisibility: Model.attribute('feedback_visibility'),
  isPaidContent: Model.attribute('is_paid_content'),
  viewPrice: Model.attribute('view_price'),
  status: Model.attribute('status'),
  caseData: Model.attribute('case_data'),
  tarotParams: Model.attribute('tarot_params'),
  engineResult: Model.attribute('engine_result'),
  assignedMentorId: Model.attribute('assigned_mentor_id'),
  reviewedBy: Model.attribute('reviewed_by'),
  interpretationLockedAt: Model.attribute('interpretation_locked_at', Model.transformDate),
  createdAt: Model.attribute('created_at', Model.transformDate),
  updatedAt: Model.attribute('updated_at', Model.transformDate),

  user: Model.hasOne('user'),
  assignedMentor: Model.hasOne('assignedMentor'),
  interpretation: Model.hasOne('interpretation'),
  mentorReview: Model.hasOne('mentorReview'),
  followUps: Model.hasMany('followUps'),
  feedbacks: Model.hasMany('feedbacks'),
  purchases: Model.hasMany('purchases'),
  aiReport: Model.hasOne('aiReport'),
});

/**
 * Check if the case author's interpretation has been locked (by mentor review).
 * Mirrors the PHP TaroCase::isInterpretationLocked() logic.
 */
TaroCase.prototype.isInterpretationLocked = function () {
  return this.interpretationLockedAt() !== null && this.interpretationLockedAt() !== undefined;
};
